import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/stockReceipt`;

export const receiptService = {
  getAll,
  getSuggestion,
  search,
  getById,
  printPdf,
  printBarcode,
  exportExcel,
  create,
  update,
  updateLine,
  delete: _delete,
  deleteLine,
  deleteLineItem,
  downloadExcelStockDetails,
  downloadCsvStockDetails,
  updateStatus,
  getViewById,
  getDocuments,
  getHistory,
};

function getAll() {
  return fetchWrapper.get(baseUrl);
}

function getHistory(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/history`);
}


function getDocuments(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/document`);
}

function getViewById(id) {
  return fetchWrapper.get(`${baseUrl}/stockReceiptView/${id}`);
}

function search(params) {
  return fetchWrapper.get(`${baseUrl}${params}`);
}

function getSuggestion(params) {
  return fetchWrapper.get(`${baseUrl}/suggestion${params}`);
}

function getById(id) {
  return fetchWrapper.get(`${baseUrl}/${id}`);
}

function printPdf(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/printPdf`, {
    responseType: "blob",
  });
}

function printBarcode(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/printBarcode`, {
    responseType: "blob",
  });
}

function exportExcel(params) {
  return fetchWrapper.get(`${baseUrl}/export-excel${params}`, {
    responseType: "blob",
  });
}

function create(params) {
  return fetchWrapper.post(baseUrl, params);
}

function update(id, params) {
  return fetchWrapper.put(`${baseUrl}/${id}`, params);
}

function updateLine(id, lineId, params) {
  return fetchWrapper.put(`${baseUrl}/${id}/line/${lineId}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`${baseUrl}/${id}`);
}

function deleteLine(id, lineId) {
  return fetchWrapper.delete(`${baseUrl}/${id}/line/${lineId}`);
}

function updateStatus(id, params) {
  return fetchWrapper.put(`${baseUrl}/${id}/updateStatus`, params);
}

function deleteLineItem(id, stockItemId) {
  return fetchWrapper.delete(`${baseUrl}/${id}/lineItem/${stockItemId}`);
}

function downloadExcelStockDetails(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/excel-stock-info`, {
    responseType: "blob",
  });
}

function downloadCsvStockDetails(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/csv-stock-info`, {
    responseType: "blob",
  });
}
